import React from 'react';
import PropTypes from 'prop-types';
import createUniqueId from '../../helpers/createUniqueId';
import ProductCard from '../ProductCard/ProductCard';


const RecommendedProducts = function RecommendedProductsComponent({
  recommendedProducts,
  title,
  analytics,
  list,
  titleClasses,
}) {
  if (!recommendedProducts || recommendedProducts.length === 0) {
    return null;
  }

  return (
    <div className="se-tier">
      <div className="se-container">
        <h2 className={`recommended-products__title ${titleClasses}`}>{title}</h2>
        <div className="recommended-products__wrapper">
          { recommendedProducts.map(product => (
            <div className="recommended-products__card-wrapper" key={createUniqueId(product.id)}>
              <ProductCard product={product} analytics={analytics} list={list} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

RecommendedProducts.propTypes = {
  recommendedProducts: PropTypes.arrayOf(PropTypes.shape({
    productID: PropTypes.string,
    details: PropTypes.shape({}),
  })),
  title: PropTypes.string,
  analytics: PropTypes.shape({}).isRequired,
  list: PropTypes.string.isRequired,
  titleClasses: PropTypes.string,
};

RecommendedProducts.defaultProps = {
  titleClasses: '',
  recommendedProducts: [],
  title: 'Recommended Products',
};

export default RecommendedProducts;
